<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <backlink/>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="ibox">
          <div class="ibox-content">
            <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options"></AdminForm>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "AdminOrderForm",
  components: {
    AdminForm
  },
  data() {
    return {
      config: config,
      form: {},
      isBusy: false
    };
  },
  computed: {
    options: function() {
      return {
        created_by_user_id: this.$store.getters[
           "user/getAll"
         ].selectOptions("id", "firstname"),
        //vehicle_id_options: this.$store.getters[
        //   "vehicle/getAll"
        //].selectOptions("id", "name")
      };
    }
  },
  mounted() {

    this.$store.dispatch("user/getAll");

    // Edition
    if (this.$route.name == config.edit_route_name) {
      this.isBusy = true;
      this.$store
        .dispatch(config.store_namespace + "/getAll", true)
        .then(() => {
          let item = this.$store.getters[config.store_namespace + "/getItem"](
            this.$route.params.id
          );
          this.form = {
            ...item,
            //user_id: item.createdByUser ? item.createdByUser.id : null,
            //vehicle_id: item.vehicle ? item.vehicle.id : null,
            // company_type_id: item.company_type ? item.company_type.id : null,
            // company_group_id: item.company_group ? item.company_group.id : null
          };
          this.isBusy = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Order/AdminOrderForm.vue